'use client';
import { getCookie } from '../helpers/getCookie';

export const getAnalyticsTrackingId = () => {
  try {
    const id = window['gaGlobal']?.vid || getCookie('_ga')?.slice(6) || null;

    return id;
  } catch {
    return null;
  }
};

export default getAnalyticsTrackingId;
